import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GeneralInnovationActivityResultsService } from '../../../../services/general-innovation-activity-results.service';
import { HistoryDownloadService, PARALLEL_YEARS } from '../../../../services/history-download.service';

export interface ThematicHistoryDownloadData {
  query: string;
  themeName: string | null;
}

type Preset = 5 | 10 | 'custom';

/** Picks reference years, then hands the job to HistoryDownloadService (progress shows in the tray). */
@Component({
  selector: 'app-thematic-history-download-popup',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './thematic-history-download-popup.component.html',
  styleUrl: './thematic-history-download-popup.component.css',
})
export class ThematicHistoryDownloadPopupComponent implements OnInit {
  availableYears: number[] = [];
  dateEom = '';
  preset: Preset = 5;
  customYears = new Set<number>();
  includeLatest = true;
  errorMessage: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<ThematicHistoryDownloadPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ThematicHistoryDownloadData,
    private apiService: GeneralInnovationActivityResultsService,
    private downloads: HistoryDownloadService,
  ) {}

  ngOnInit(): void {
    this.apiService.getTopCompaniesHistoryYears().subscribe({
      next: res => {
        this.availableYears = res.payload.years;
        this.dateEom = res.payload.date_eom;
      },
      error: () => this.errorMessage = 'Could not load the available reference years.',
    });
  }

  get selectedYears(): (number | null)[] {
    const years = this.preset === 'custom'
      ? this.availableYears.filter(y => this.customYears.has(y))
      : this.availableYears.slice(0, this.preset);
    return this.includeLatest ? [null, ...years] : years;
  }

  /** Worst case for broad themes: ~1 min per year, PARALLEL_YEARS at a time. */
  get estimateMinutes(): number {
    return Math.max(1, Math.ceil(this.selectedYears.length / PARALLEL_YEARS));
  }

  toggleYear(year: number): void {
    this.customYears.has(year) ? this.customYears.delete(year) : this.customYears.add(year);
  }

  download(): void {
    if (!this.selectedYears.length) return;
    this.downloads.start(this.data.query, this.data.themeName, this.selectedYears);
    this.dialogRef.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
